import { ReactNode, useState } from 'react';
import Close from '@material-ui/icons/Close';
import Add from '@material-ui/icons/Add';
import * as styles from './styles/styles.module.scss';

type Props = {
  children: ReactNode;
  classes: string;
  collapsed?: boolean;
  title: ReactNode;
};

const Expandable = ({ title = '', collapsed = true, classes = '', children }: Props) => {
  const [isCollapsed, toggleIsCollapsed] = useState(collapsed);

  const toggleContent = () => {
    toggleIsCollapsed(prevState => !prevState);
  };

  return (
    <div className={`${styles.container} ${classes}`}>
      <div onClick={toggleContent} className={styles.control}>
        <div className={styles.title}>{title}</div>
        <div className={styles.toggleButton}>{isCollapsed ? <Add /> : <Close />}</div>
      </div>
      <div className={`${isCollapsed ? styles.collapsed : styles.collapsible}`}>{children}</div>
    </div>
  );
};

export default Expandable;
